import { startDriverActivitiesListeners } from "./ducks/data/driver-activities/listeners";
import { startDeliveriesListeners } from "./ducks/data/deliveries/listeners";

// Every listener registered on listenerMiddleware, in one place so tests can
// clear them (cancelling any still waiting) and start them fresh.
export const startListeners = () => {
  startDriverActivitiesListeners();
  startDeliveriesListeners();
};
